import { AxiosPromise } from 'axios';
import { IGetAttendance, IGetStudents, IStudentReq, IGetRegistration } from '../models/campusClasses2.model';
import axios from 'axios';

const uri = '/mgmt/campus-classes';

// 학급의 학생 목록
export const getStudents = (classCode: string, semesterCode?: number): AxiosPromise<IGetStudents> => {


  console.log(semesterCode, semesterCode != null && isNaN(semesterCode))

  return axios.get(`${uri}/${classCode}/students`, {
    params: {
      semesterCode: semesterCode != null && isNaN(semesterCode) ? 0 : semesterCode,
    },
  });
}

// 학급에 학생 추가
export const createStudent = (classCode: string, data: IStudentReq): AxiosPromise => {
  return axios.post(`${uri}/${classCode}/student`, data);
};

// 학급에 학생 추가(일괄등록)
export const createMultiStudent = (classCode: string, data: IStudentReq[]): AxiosPromise => {
  return axios.post(`${uri}/${classCode}/multiStudent`, data);
};

// 학생 개인의 출석 목록
export const getAttendance = (classStudentCode: string): AxiosPromise<IGetAttendance> => {
  return axios.get(`${uri}/classes/${classStudentCode}`);
}

export const getRegistration = (classCode: string, memberCode: string): AxiosPromise<IGetRegistration> => {
  return axios.get(`${uri}/${classCode}/${memberCode}/student`);
}

// 학생 삭제
export const deleteStudent = (classStudentCode: number): AxiosPromise => {
  return axios.delete(`${uri}/classes/${classStudentCode}`);
};
